<div class="tw-flex tw-justify-between">
    <i class="fa fa-arrow-alt-to-bottom tw-mb-3 tw-text-gray-100 tw-text-3xl tw-cursor-pointer" (click)="close('download')" [mhTooltip]="'commons.download' | translate" position="above"></i>
    <i class="fa fa-times tw-ml-auto tw-text-gray-100 tw-text-3xl tw-cursor-pointer" (click)="close()"></i>
</div>

<article class="tw-max-h-[80vh] tw-overflow-y-auto">
    <section *ngIf="data.type === 'image'" class="tw-flex tw-justify-center">
        <img [src]="data.file?.link || data.file" class="tw-w-[36rem] tw-h-auto">
    </section>
</article>